<button (click)="openMap()"
        mat-icon-button
        aria-label="Wechseln zur Karte"
        class="hover-button mdc-fab-mini">
    <mat-icon>fullscreen</mat-icon>
    <span class="text-on-hover">{{'floating_button.map.open' | translate}}</span>
</button>